import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { DollarSign, MapPin, Clock, Send } from "lucide-react";
import { useState } from "react";

interface QuickActionsProps {
  onPriceOffer?: (price: number) => void;
  onLocationSuggest?: (location: string) => void;
  onTimeSuggest?: (time: string) => void;
  currentPrice?: number;
}

export function QuickActions({
  onPriceOffer,
  onLocationSuggest,
  onTimeSuggest,
  currentPrice,
}: QuickActionsProps) {
  const [priceOffer, setPriceOffer] = useState<string>("");
  const [location, setLocation] = useState<string>("");
  const [time, setTime] = useState<string>("");

  const handlePriceOffer = () => {
    const price = parseFloat(priceOffer);
    if (!isNaN(price) && price > 0 && onPriceOffer) {
      onPriceOffer(price);
      setPriceOffer("");
    }
  };

  const handleLocationSuggest = () => {
    if (location.trim() && onLocationSuggest) {
      onLocationSuggest(location.trim());
      setLocation("");
    }
  };

  const handleTimeSuggest = () => {
    if (time.trim() && onTimeSuggest) {
      onTimeSuggest(time.trim());
      setTime("");
    }
  };

  return (
    <Card className="border-primary/20 bg-primary/5">
      <CardContent className="p-4 space-y-3">
        <h3 className="font-semibold text-sm mb-3">빠른 제안</h3>

        {/* Price Offer */}
        {onPriceOffer && (
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <DollarSign className="h-4 w-4 text-muted-foreground" />
              <span className="text-sm font-medium">가격 제안</span>
            </div>
            <div className="flex gap-2">
              <input
                type="number"
                placeholder={currentPrice ? `현재: $${currentPrice}` : "가격 입력"}
                value={priceOffer}
                onChange={(e) => setPriceOffer(e.target.value)}
                className="flex-1 px-3 py-2 text-sm border rounded-md bg-background"
              />
              <Button
                size="sm"
                onClick={handlePriceOffer}
                disabled={!priceOffer || isNaN(parseFloat(priceOffer))}
              >
                <Send className="h-3 w-3" />
              </Button>
            </div>
          </div>
        )}

        {/* Location Suggest */}
        {onLocationSuggest && (
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <MapPin className="h-4 w-4 text-muted-foreground" />
              <span className="text-sm font-medium">거래 장소 제안</span>
            </div>
            <div className="flex gap-2">
              <input
                type="text"
                placeholder="예: Chatswood역 앞"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                className="flex-1 px-3 py-2 text-sm border rounded-md bg-background"
              />
              <Button
                size="sm"
                onClick={handleLocationSuggest}
                disabled={!location.trim()}
              >
                <Send className="h-3 w-3" />
              </Button>
            </div>
          </div>
        )}

        {/* Time Suggest */}
        {onTimeSuggest && (
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <Clock className="h-4 w-4 text-muted-foreground" />
              <span className="text-sm font-medium">거래 시간 제안</span>
            </div>
            <div className="flex gap-2">
              <input
                type="text"
                placeholder="예: 오후 3시, 토요일 오전"
                value={time}
                onChange={(e) => setTime(e.target.value)}
                className="flex-1 px-3 py-2 text-sm border rounded-md bg-background"
              />
              <Button
                size="sm"
                onClick={handleTimeSuggest}
                disabled={!time.trim()}
              >
                <Send className="h-3 w-3" />
              </Button>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}

